import React, { useEffect, useState } from 'react';
import '../static/table.css';
import '../static/popup.css';
import axios from 'axios';

const Staff = () => {

  const [groomingData, setGroomingData] = useState([]);
  const currentDate = new Date();
 const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(currentDate.getDate()).padStart(2, '0');
  const formattedDate = `${month}-${day}`; // mm-dd

  const [staffList, setStaffList] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    status: '',
    fromday: '',
    endday: '',
    paidday: '',
    workingday: '',
    absentday: '',
    done: '',
    duty: '',
  });
  const [showPopup, setShowPopup] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');

  useEffect(() => {
    fetchStaff();
  }, []);

  const fetchStaff = async () => {
    try {
      const res = await axios.get('/staff/');
      setStaffList(res.data);
    } catch (err) {
      console.error("Failed to fetch staff data:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

const handleSubmitPresent = async (e) => {
e.preventDefault();

try {
  const response = await axios.put("/create_stuff/", formData);

  if (response.ok) {
    setResponseMessage("Pet walking note update successfully.");
    alert("Pet walking note update successfully.");
  } else {
    const errorData = await response.json();
    setResponseMessage("Failed to note update entry: " + JSON.stringify(errorData));
  }
} catch (error) {
  console.error("Error submitting form:", error);
  setResponseMessage("An error occurred. Please try again.");
  alert("An error occurred. Please try again.");
}
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/create-staff/', formData);
      setResponseMessage('Staff added successfully');
      fetchStaff(); // refresh list
      setShowPopup(false);
    } catch (err) {
      console.error('Error creating staff:', err);
      setResponseMessage('Failed to add staff');
    }
  };

  return (
    <div className="container">
      <h2 className="text-center">Staff Management</h2>
      <button className='button' onClick={() => setShowPopup(true)}>Add Staff</button>

      {showPopup && (
        <form className="contact-form" onSubmit={handleSubmit}>
          {['name', 'status', 'fromday', 'endday', 'paidday', 'workingday', 'absentday', 'done', 'duty'].map((field) => (
            <div className="input-block" key={field}>
              <label>{field}</label>
              <input
                type={field.includes('day') ? 'date' : 'text'}
                name={field}
                value={formData[field]}
                onChange={handleChange}
                className="form-control"
              />
            </div>
          ))}
          <button type="submit" className="square-button">Submit</button>
          <button className='button' onClick={() => setShowPopup(false)}>Cancel</button>
        </form>
      )}

      <div className="table-responsive mt-3">
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th>Name</th>
              <th>Status</th>
              <th>From</th>
              <th>Present Today</th>
              <th>Paid Month</th>
              <th>Pay Amount</th>
              <th>Working Day</th>
              <th>duty</th>
            </tr>
          </thead>
          <tbody>
            {staffList.map((staff, idx) => (
               <React.Fragment key={idx}>
              <tr>
                <td>{staff.name}</td>
                <td>{staff.status}</td>
                <td>{staff.frommonth}</td>
                <td>{staff.datepresent}</td>
                <td>{staff.paidday}</td>
                <td>{staff.paidamount}</td>
                <td>{staff.workingday}</td>
                <td>{staff.duty}</td>
              </tr>
               <tr> 
                                                    
                <td colSpan="11"> {/* span all columns if needed */}
                  <form className="contact-form" onSubmit={handleSubmitPresent}>
                    <td>
                    <div className="input-block">
                       <label>Presence of Today</label>
                      <select name="datepresent" value={formData.datepresent} onChange={handleChange} className="form-control">
                        <option value={
                            formData.frommonth === month && formData.lastpresentday !== day
                              ? formData.datepresent + 1
                              : 1
                          } selected>today Present</option>
                        <option value={formData.datepresent} >Absent</option>
                      </select>
                     </div>
                    </td><td>
                     <label>First Unpaid Month</label>
                      <div className="input-block">
                        <input type="month" name="frommonth" value={formData.frommonth} className="form-control" />
                      </div>
                      </td><td>
                        <label>Update Note About Him/Her</label>
                    <textarea name="note" cols={40} rows={4} className="form-control mb-2" value={formData.note} />
                    <input type="hidden" name="lastpresentday " value={formattedDate } />
                    <input type="hidden" name="workingday " value={formattedDate } />
                    <input type="hidden" name="id " value={formData.id } />
                    <button type="submit" className="btn btn-success btn-sm">Update Stuff</button>
                  </td>
                  </form>
                </td>
                    
                
            </tr>     
            </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      {responseMessage && <p>{responseMessage}</p>}
    </div>
  );
};

export default Staff;
